<template lang="pug">
.generic-wrapper
  .container
    BackButton(name="CMSOverview")
    h1.title Tagestipps
    .sub-headline Hier können Sie alle Tagestipps verwalten.
  
    .tip-wrapper.margin-top(ref="canvas" @mouseup="stopDrag()" @mousemove="updateMousePos")
      .left
        table
          thead
            tr
              th.smaller(colspan="7")
                div
                  b-button(size="is-small" icon-left="arrow-left" @click="changeDate('before')")
                  .name {{monthNames[this.month-1]}} {{this.year}}
                  b-button(size="is-small" icon-left="arrow-right" @click="changeDate('after')")
            tr
              th Mo
              th Di
              th Mi
              th Do
              th Fr
              th Sa
              th So
          tbody
            tr(v-for="w in weeks")
              td(v-for="d in 7"
                :class="{invalid: dayNumber(d, w) <= 0 || dayNumber(d, w) > daysInMonth}" @mouseenter="cellDay = dayNumber(d, w)" @mouseleave="cellDay = null")
                .nr-wrapper(:class="{'drag-hover': dragActive, highlight: year === new Date().getFullYear() && month-1 === new Date().getMonth() && dayNumber(d, w) === new Date().getDate()}")
                  perfect-scrollbar
                    .nr {{dayNumber(d, w)}}
                    .tips-wrapper
                      .tip(v-for="tip in dailyTips"
                            v-if="year === new Date(tip.date).getFullYear() && month-1 === new Date(tip.date).getMonth() && dayNumber(d, w) === new Date(tip.date).getDate()"
                            @click="deleteTip(tip)") {{tip.rentObject.code}}

      .right
        .search
          b-input(placeholder="Nach Code suchen" v-model="filterString" autofocus)
        .dragndrop( v-for="r, idx in rentObjects"
                    @mouseenter="ddSelected = r"
                    @mousedown="startDrag(idx)"
                    :class="{dragging: r.id === ddSelected.id && dragActive}"
                    v-if="r.code.toString().toLowerCase().indexOf(filterString.toLowerCase()) >= 0")
          .d-title {{r.name}}
          .d-info {{r.code}}

      .dragndrop.shadow(ref="shadow" :class="{active: dragActive}")
          .d-title {{ddSelected.name}}
          .d-info {{ddSelected.code}}


</template>

<script>
import { DateTime } from 'luxon';

export default {
  data() {
    return {
      filterString: "",
      canvasRect: null,
      dragActive: false,
      cellDay: null,
      mousePos: {x: 0, y: 0},
      rentObjectTypeUUIDs: ['HOUSE', 'APPARTMENT'],
      month: DateTime.local().month,
      year: DateTime.local().year,
      ddSelected: {
        id: -1,
        name: 'Placeholder',
        bookedDays: 12
      },
      monthNames: [
        'Januar',
        'Februar',
        'März',
        'April',
        'Mai',
        'Juni',
        'Juli',
        'August',
        'September',
        'Oktober',
        'November',
        'Dezember'
      ]
    }
  },
  computed: {
    rentObjects() {
      return this.$store.state.rentObjects.all.filter(r => this.selectedRentObjectTypeIds.includes(r.rentObjectTypeId));
    },
    rentObjectTypes() {
      return this.$store.state.rentObjectTypes.all;
    },
    selectedRentObjectTypeIds() {
      const ids = [];
      this.rentObjectTypeUUIDs.forEach(r => {
        const newId = this.rentObjectTypes.find(t => t.uuid === r);
        if (newId) {
          ids.push(newId.id);
        }
      });
      return ids;
    },
    daysInMonth () {
      const d = DateTime.local(this.year, this.month, 1)
      return d.daysInMonth
    },
    startWeekday () {
      const d = DateTime.local(this.year, this.month, 1)
      return d.weekday
    },
    weeks () {
      return Math.ceil((this.daysInMonth + this.startWeekday - 1) / 7)
    },
    dailyTips () {
      return this.$store.state.dailyTips.all;
    }
  },
  mounted() {
    this.$store.dispatch("rentObjects/findAll");
    this.$store.dispatch("rentObjectTypes/findAll");
    this.$store.dispatch("dailyTips/findAll", {year: this.year, month: this.month});
    this.canvasRect = this.$refs.canvas.getBoundingClientRect();
  },
  methods: {
    changeDate(dir) {
      if (dir === 'before') {
        let d = DateTime.fromObject({year: this.year, month: this.month, day: 1}).minus({month: 1});
        this.month = d.month;
        this.year = d.year;
      } else {
        let d = DateTime.fromObject({year: this.year, month: this.month, day: 1}).plus({month: 1});
        this.month = d.month;
        this.year = d.year;
      }
      this.$store.dispatch("dailyTips/findAll", {year: this.year, month: this.month});
    },
    deleteTip(tip) {
      this.$buefy.dialog.confirm({
        title: "Tagestipp löschen",
        message: `Sind Sie sicher, dass Sie diesen Tagestipp für <b>${tip.rentObject.code}</b> löschen möchten? Diese Aktion kann nicht rückgängig gemacht werden.`,
        confirmText: "Tagestipp löschen",
        cancelText: "Abbrechen",
        type: "is-danger",
        hasIcon: true,
        onConfirm: async () => {
          try {
            await this.$store.dispatch("dailyTips/delete", { id: tip.id });
            this.$store.dispatch("dailyTips/findAll", {year: this.year, month: this.month});
          } catch (e) {
            this.$store.dispatch(
              "common/showError",
              "Tagestipp konnte nicht gelöscht werden."
            );
          }
        }
      });
    },
    dayNumber (d, w) {
      return d + (w - 1) * 7 - this.startWeekday + 1
    },
    startDrag() {
      this.dragActive = true;
    },
    async stopDrag() {
      if (this.dragActive && this.ddSelected.id > 0 && this.cellDay !== null && this.cellDay > 0) {
        const d = DateTime.fromObject({year: this.year, month: this.month, day: this.cellDay});
        try {
          await this.$store.dispatch("dailyTips/create", {rentObjectId: this.ddSelected.id, date: d.toISODate()});
          await this.$store.dispatch("dailyTips/findAll", {year: this.year, month: this.month});
        } catch {
          // nothing here
        }
      }

      // Reset data
      this.dragActive = false;
      this.ddSelected = {
        id: -1,
        name: 'Placeholder',
        bookedDays: 12
      };
    },
    updateMousePos(e) {
      var x = Math.floor(e.pageX - this.canvasRect.left); //x position within the element.
      var y = Math.floor(e.pageY - this.canvasRect.top);  //y position within the element.
      this.mousePos = {
        x,
        y
      }
      // this.$refs.shadow.style.transform = `translate(${this.mousePos.x}px, ${this.mousePos.y}px)`
      this.$refs.shadow.style.left = this.mousePos.x+'px';
      this.$refs.shadow.style.top = this.mousePos.y+'px';
    }
  }
}
</script>

<style lang="scss" scoped>
.tip-wrapper {
  position: relative;
  display: grid;
  grid-template-areas: "left right";
  grid-template-columns: auto 320px;
  grid-template-rows: calc(100vh - 314px);
  border-radius: 3px;
  border: solid 1px $light;
  overflow: hidden;
  user-select: none;

  .left {
    grid-area: left;
    background-color: white;
    .invalid {
      .nr-wrapper {
        display: none;
      }
    }
    table {
      width: calc(100% - 1px);
      max-height: calc(100% - 1px);
      table-layout: fixed;
      tr {
        border: solid 1px $lightgray;
        td {
          border: solid 1px $lightgray;
        }
      }
      thead {
        tr {
          text-align: center;
          &:first-child {
            th {
              color: black !important;
              div {
                display: flex;
                justify-content: space-between;
                align-items: center;
              }
            }
          }
        }
      }
    }
    .nr-wrapper {
      position: relative;
      width: 100%;
      overflow: hidden;
      &.drag-hover {
        &:hover {
          background-color: $primary;
          .nr {
            color: white;
          }
        }
      }
      &.highlight {
        background-color: $secondary;
      }
      .ps {
        height: calc((100vh - 314px - 55px)/6);
      }
      .nr {
        display: inline;
        position: absolute;
        top: $xs-space;
        left: $xs-space;
        font-size: 0.8rem;
        font-weight: 500;
        color: $darkgray;
      }
      .tips-wrapper {
        padding: $md-space $xs-space $sm-space 0;
        font-size: 0.8rem;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        flex-wrap: wrap;
        .tip {
          background-color: $light;
          display: inline;
          border: solid 1px $lightgray;
          border-radius: 3px;
          margin-left: $xs-space;
          margin-bottom: $xs-space;
          &:hover {
            background-color: $danger;
            border-color: $danger;
            color: white;
            cursor: pointer;
          }
        }
      }
    }
  }
  .right {
    position: relative;
    overflow-y: auto;
    grid-area: right;
    background-color: $lightgray;
    .search {
      position: sticky;
      top: 0,
    }
  }
}

.dragndrop {
  background-color: $light;
  border-radius: 3px;
  box-shadow: $shadow-md;
  margin: $sm-space;
  padding: $sm-space;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  user-select: none;
  cursor: pointer;
  &.shadow {
    margin: 0;
    position: absolute;
    opacity: 0;
    transform: rotate(8deg) translate(-50%, -20%);
    box-shadow: $shadow-lg;
    pointer-events: none;
    &.active {
      opacity: 0.72;
    }
  }
  &.dragging {
    opacity: 0;
  }
  .d-title {
    font-weight: 500;
  }
  .d-info {
    display: inline-block;
    padding: 2px 4px;
    border-radius: 3px;
    margin-left: $sm-space;
    background-color: rgba($danger, 0.4);
  }
}

</style>